module.exports = __webpack_public_path__ + "static/media/Municipalitiesblack.12edf7a0.svg";